import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducer';
import { saveState, loadState } from './local_storage';
import { getPendingItemIds, getPendingItems } from './reducer';

import { submitSnapForm } from './snapit_app/actions'

const middleware = [
  applyMiddleware(thunk),
];

if (process.env.NODE_ENV !== 'production') {
  if (window.devToolsExtension) {
    middleware.push(window.devToolsExtension());
  }
}

const createStoreWithMiddleware = compose(...middleware)(createStore);

export function configureStore(initialState) {
  const store = createStoreWithMiddleware(rootReducer, initialState);

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept('./reducer', () => {
        // eslint-disable-next-line global-require,import/newline-after-import
        const nextRootReducer = require('./reducer');
        store.replaceReducer(nextRootReducer);
      });
    }
  }

  return store;
}


export function configureStoreWithLocalStore() {
  const store = configureStore(loadState());
  let cachedState = store.getState();


  //--upload any pending_items retrieved from the cached store
  const pending_item_ids = getPendingItemIds(cachedState);
  const pending_items = getPendingItems(cachedState);

  pending_item_ids.map((pending_item_id) => {

    let pending_item = pending_items.get(pending_item_id);

    store.dispatch(submitSnapForm(pending_item.name,pending_item.description,pending_item.internal_notes,pending_item.category_id,pending_item.venue_id,pending_item.image,pending_item.api_token,pending_item.venue_permalink,pending_item.account_subdomain,pending_item.pending_id));
    return true;
  });

  store.subscribe(() => {
    const currentState = store.getState();

    if (cachedState !== currentState) {
      saveState(currentState);
      cachedState = currentState;
    }
  });
  return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.js